// extracted by mini-css-extract-plugin
export default {"required-asterisk":"required-asterisk_pXD7ORYv","required-field":"required-field_PWVQA8S8","read-only-value":"read-only-value_npO39TDq"};